import React from "react";
import "./LoginVideoBox.css";
import LoginVideoBoxGIF from "../../assets/VideoBoxScreenRecord.gif";

// Importing profile images
import LoginProfile1 from "../../assets/VideoBoxProfilePhotos/Profile1.png";
import LoginProfile2 from "../../assets/VideoBoxProfilePhotos/Profile2.png";
import LoginProfile3 from "../../assets/VideoBoxProfilePhotos/Profile3.png";
import LoginProfile4 from "../../assets/VideoBoxProfilePhotos/Profile4.png";
import LoginProfile5 from "../../assets/VideoBoxProfilePhotos/Profile5.png";
import LoginProfile6 from "../../assets/VideoBoxProfilePhotos/Profile6.png";
import LoginProfile7 from "../../assets/VideoBoxProfilePhotos/Profile7.png";
import LoginProfile8 from "../../assets/VideoBoxProfilePhotos/Profile8.png";
import LoginProfile9 from "../../assets/VideoBoxProfilePhotos/Profile9.png";
import VideoBoxArrow from "../../assets/VideoBoxArrow.svg";

const LoginVideoBox = () => {
  return (
    <div className="login-video-box-outer">
      <div className="login-video-box-text">
        <p>Boost your content</p>
        <p>Game with Brandly!</p>
      </div>
      <div className="login-video-box-main">
        <div className="login-profile-crown">
          {[LoginProfile1, LoginProfile2, LoginProfile3, LoginProfile4, LoginProfile5, LoginProfile6, LoginProfile7, LoginProfile8, LoginProfile9].map((profile, index) => (
            <img
              src={profile}
              alt={`Profile ${index + 1}`}
              className="login-profile-img-vb"
              key={index}
            />
          ))}
        </div>
        <div className="login-video-box-inner">
          <img src={LoginVideoBoxGIF} alt="Demo Animation" className="login-video-gif" />
        </div>
      </div>
      <div className="login-video-box-arrow">
        <img src={VideoBoxArrow} alt="Video Box Arrow" />
      </div>
    </div>
  );
};

export default LoginVideoBox;
